import { render, staticRenderFns } from "./PostCreateAuto.vue?vue&type=template&id=b1afeed2"
import script from "./PostCreateAuto.vue?vue&type=script&lang=js"
export * from "./PostCreateAuto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports